module.exports = __webpack_public_path__ + "img/pin-fill.f6e50c44.svg";